// Components
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// Slices
import { organizationNodesSelector } from 'slices/organizationHierarchy.slice';
import { rolesSelector } from 'slices/roles.slice';
import { Icon, TEInput } from '@timeedit/ui-components';
// Types
import './OrgAndRoleRow.scss';

type IOrgAndRoleOption = {
  role: string;
  value: string;
  label: string;
  disabled: boolean;
  key: string;
};

type OrgAndRoleRowProps = {
  index: number;
  option: IOrgAndRoleOption;
  onUpdate: (colIdx: number, rowIdx: number, value: string) => void;
  onDelete: (rowIdx: number) => void;
};

export const OrgAndRoleRow = ({
  onUpdate,
  onDelete,
  option,
  index,
}: OrgAndRoleRowProps) => {
  const allRoles = useSelector(rolesSelector);
  const allOrganizationNodes = useSelector(organizationNodesSelector);

  // Prepare organization nodes and roles for display in the select inputs
  const formattedOrgNodes = useMemo(() => {
    return allOrganizationNodes.map((node) => ({
      value: node.id || '',
      label: node.name,
    }));
  }, [allOrganizationNodes]);

  const formattedRoles = useMemo(() => {
    return allRoles.map((role) => ({
      value: role.id || '',
      label: role.name,
    }));
  }, [allRoles]);

  return (
    <div className="org-and-role-row--wrapper">
      <div className="org-and-role-selectors">
        <TEInput.Select
          placeholder="Organization node"
          showSearch
          onChange={(newValue) => onUpdate(0, index, newValue)}
          options={formattedOrgNodes}
          style={{ width: '100%' }}
          key={`${option.value}-orgNode-${index}`}
          value={option.label || undefined}
          onClear={() => onUpdate(0, index, '')}
          filterOption={(inputValue, option: any) => {
            return option?.label
              ?.toLowerCase()
              .includes(inputValue?.toLowerCase());
          }}
          data-testid={`organization-node-select-${index}`}
        />
        <TEInput.Select
          placeholder="Role"
          showSearch
          key={`${option.role}-role-${index}`}
          onChange={(newVal) => onUpdate(1, index, newVal)}
          options={formattedRoles}
          style={{ width: '100%' }}
          value={option.role || undefined}
          filterOption={(inputValue, option: any) => {
            return option?.role
              ?.toLowerCase()
              .includes(inputValue?.toLowerCase());
          }}
          data-testid={`role-select-${index}`}
        />
      </div>
      <Icon id="DeleteOutlined" alt="Delete" onClick={() => onDelete(index)} />
    </div>
  );
};
